module.exports = __webpack_public_path__ + "static/media/add-fill.560a979f.svg";